module.exports = __webpack_public_path__ + "img/device_cover_a.f532a3a7.png";